import { createDeferredI18n } from "#/shared/composables/useI18n";

import fallbackMessages from "#/shared/i18n/frontend.insurance_app.json";

// Installed as a plugin in main.js; `whenI18nReady` gates the root's first
// paint until the `frontend.insurance_app` strings are hydrated.
export const { i18n, ready: whenI18nReady } = createDeferredI18n({ key: "insurance_app", fallbackMessages });
